import { AuthenticatedUser } from '@/models/auth.model';

export interface SessionUserDTO {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  job_title?: string;
  department?: string;
  company_name?: string;
  office_location?: string;
  employee_type?: string;
  manager_name?: string;
  assumed_role?: string;
  functional_groups?: string[];
}

export interface SsoStartResponseDTO {
  authorization_url: string;
  state: string;
}

export interface SsoCallbackResponseDTO {
  access_token: string;
  token_type: string;
  expires_in: number;
  user: SessionUserDTO;
  /** Entra access token for this app — send as X-Microsoft-OBO-Assertion for SharePoint resolve. */
  microsoft_obo_assertion?: string | null;
}

export interface SessionResponseDTO {
  authenticated: boolean;
  user: SessionUserDTO;
  /** JWT echoed from the validated cookie so the frontend can restore in-memory state. */
  access_token: string;
}

export interface MicrosoftOboRefreshResponseDTO {
  microsoft_obo_assertion?: string | null;
}

export const mapSessionUserDTO = (dto: SessionUserDTO): AuthenticatedUser =>
  new AuthenticatedUser(
    dto.id,
    dto.email,
    dto.first_name,
    dto.last_name,
    dto.job_title ?? '',
    dto.department ?? '',
    dto.company_name ?? '',
    dto.office_location ?? '',
    dto.employee_type ?? '',
    dto.manager_name ?? '',
    dto.assumed_role ?? 'EMPLOYEE',
    dto.functional_groups ?? [],
  );
